module.exports = __webpack_public_path__ + "static/media/crowns.29ba5305.svg";